"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExperimentId = (function () {
    function ExperimentId(id) {
        this.id = id;
        var pattern = "^[A-Za-z0-9-_]{1,64}$";
        if (!new RegExp(pattern).test(id)) {
            throw new RangeError("Unable to construct ExperimentId: value must match pattern " + pattern + " (Given: " + id + ")");
        }
        this.id = id;
    }
    ExperimentId.prototype.toJSON = function () {
        return this.id;
    };
    return ExperimentId;
}());
exports.ExperimentId = ExperimentId;
//# sourceMappingURL=ExperimentId.js.map